import type { ReactNode } from "react";

/** The shared destructive banner for inline fetch/mutation errors. */
export function ErrorBanner({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-md border border-destructive/50 bg-destructive/10 px-3 py-2 text-sm text-destructive">
      {children}
    </div>
  );
}
